export default __webpack_public_path__ + "a9a20f88e6e4e56d24e13592af4517ae.png";